export type JourneyStepFieldMappingReview = {
  acknowledged_at: string;
};

export function readJourneyStepFieldMappingReview(step: Record<string, unknown>): JourneyStepFieldMappingReview | null {
  const raw = step.field_mapping_review as JourneyStepFieldMappingReview | undefined;
  if (!raw?.acknowledged_at) return null;
  return raw;
}

export function isJourneyStepMappingReviewed(step: Record<string, unknown>): boolean {
  return readJourneyStepFieldMappingReview(step) !== null;
}
